import { RECIPE_SITES, recipeApp, type OsRecipe } from '../os-recipes.js';

const CHROME = recipeApp('com.google.Chrome');

/** chrome: its app recipes as data (Mac recipes R3). Every entry ships held until its drill lifts it.
 *  The research rows not here are the legacy recipes (os-recipes.ts) or on the R3 review lists. */
export const RECIPES: readonly OsRecipe[] = [
  // A close loses what the tab held (a half-filled form): the lint keeps chrome.close_tab for the yes.
  {
    id: 'chrome.close_tab', app: CHROME, status: 'held',
    title: 'Close the Chrome tab',
    description: 'Close the Chrome tab ("close this tab").',
    params: {},
    steps: [{ op: 'activate' }, { op: 'memo' }],
    onYes: [{ op: 'verb', id: 'chrome.close_tab', params: {} }],
    tier: 'irreversible', verify: 'echo', cues: ['close this tab', 'close the tab', 'shut this tab', 'close tab', 'yeh tab band'],
    reply: 'Close this tab in Chrome?',
  },
  {
    id: 'chrome.reopen_tab', app: CHROME, status: 'held', opens: true,
    title: 'Reopen the last closed Chrome tab',
    description: 'Reopen the last closed Chrome tab ("reopen the tab I closed").',
    params: {},
    steps: [{ op: 'activate' }, { op: 'key', chord: 'cmd+shift+t' }],
    tier: 'reversible', cues: ['reopen', 'restore', 'closed', 'wapas', 'tab i closed', 'closed tab', 'oops reopen it', 'woh tab wapas'],
    reply: 'Reopened the last closed tab in Chrome.',
  },
  {
    id: 'chrome.next_tab', app: CHROME, status: 'held', opens: true,
    title: 'Go to the next Chrome tab',
    description: 'Go to the next Chrome tab ("next tab").',
    params: {},
    steps: [{ op: 'activate' }, { op: 'key', chord: 'cmd+opt+right' }],
    tier: 'reversible', cues: ['next', 'right', 'agla', 'next tab', 'tab on the right', 'agla tab'],
    reply: 'Next tab.',
  },
  {
    id: 'chrome.previous_tab', app: CHROME, status: 'held', opens: true,
    title: 'Go to the previous Chrome tab',
    description: 'Go to the previous Chrome tab ("previous tab").',
    params: {},
    steps: [{ op: 'activate' }, { op: 'key', chord: 'cmd+opt+left' }],
    tier: 'reversible', cues: ['previous', 'prev', 'left', 'pichla', 'previous tab', 'tab on the left', 'prev tab', 'pichla tab'],
    reply: 'Previous tab.',
  },
  {
    id: 'chrome.tab_1', app: CHROME, status: 'held', opens: true,
    title: 'Go to the first Chrome tab',
    description: 'Go to the first Chrome tab ("open the first tab").',
    params: {},
    steps: [{ op: 'activate' }, { op: 'key', chord: 'cmd+1' }],
    tier: 'reversible', cues: ['tab', 'first', 'one'],
    reply: 'Went to the first tab in Chrome.',
  },
  {
    id: 'chrome.tab_2', app: CHROME, status: 'held', opens: true,
    title: 'Go to the second Chrome tab',
    description: 'Go to the second Chrome tab ("second tab").',
    params: {},
    steps: [{ op: 'activate' }, { op: 'key', chord: 'cmd+2' }],
    tier: 'reversible', cues: ['tab', 'second', 'two'],
    reply: 'Went to the second tab in Chrome.',
  },
  {
    id: 'chrome.tab_3', app: CHROME, status: 'held', opens: true,
    title: 'Go to the third Chrome tab',
    description: 'Go to the third Chrome tab ("go to the third tab").',
    params: {},
    steps: [{ op: 'activate' }, { op: 'key', chord: 'cmd+3' }],
    tier: 'reversible', cues: ['tab', 'third', 'three', 'teesra tab'],
    reply: 'Went to the third tab in Chrome.',
  },
  {
    id: 'chrome.tab_4', app: CHROME, status: 'held', opens: true,
    title: 'Go to the fourth Chrome tab',
    description: 'Go to the fourth Chrome tab ("switch to tab 4").',
    params: {},
    steps: [{ op: 'activate' }, { op: 'key', chord: 'cmd+4' }],
    tier: 'reversible', cues: ['tab', 'fourth', 'four', 'tab 4'],
    reply: 'Went to the fourth tab in Chrome.',
  },
  {
    id: 'chrome.tab_5', app: CHROME, status: 'held', opens: true,
    title: 'Go to the fifth Chrome tab',
    description: 'Go to the fifth Chrome tab ("jump to tab number five").',
    params: {},
    steps: [{ op: 'activate' }, { op: 'key', chord: 'cmd+5' }],
    tier: 'reversible', cues: ['tab', 'fifth', 'five', 'tab number'],
    reply: 'Went to the fifth tab in Chrome.',
  },
  {
    id: 'chrome.tab_6', app: CHROME, status: 'held', opens: true,
    title: 'Go to the sixth Chrome tab',
    description: 'Go to the sixth Chrome tab ("go to the sixth tab in chrome").',
    params: {},
    steps: [{ op: 'activate' }, { op: 'key', chord: 'cmd+6' }],
    tier: 'reversible', cues: ['tab', 'sixth', 'six'],
    reply: 'Went to the sixth tab in Chrome.',
  },
  {
    id: 'chrome.tab_7', app: CHROME, status: 'held', opens: true,
    title: 'Go to the seventh Chrome tab',
    description: 'Go to the seventh Chrome tab ("go to the seventh tab in chrome").',
    params: {},
    steps: [{ op: 'activate' }, { op: 'key', chord: 'cmd+7' }],
    tier: 'reversible', cues: ['tab', 'seventh', 'seven'],
    reply: 'Went to the seventh tab in Chrome.',
  },
  {
    id: 'chrome.tab_8', app: CHROME, status: 'held', opens: true,
    title: 'Go to the eighth Chrome tab',
    description: 'Go to the eighth Chrome tab ("go to the eighth tab in chrome").',
    params: {},
    steps: [{ op: 'activate' }, { op: 'key', chord: 'cmd+8' }],
    tier: 'reversible', cues: ['tab', 'eighth', 'eight'],
    reply: 'Went to the eighth tab in Chrome.',
  },
  {
    id: 'chrome.last_tab', app: CHROME, status: 'held', opens: true,
    title: 'Go to the last Chrome tab',
    description: 'Go to the last Chrome tab ("go to the last tab").',
    params: {},
    steps: [{ op: 'activate' }, { op: 'key', chord: 'cmd+9' }],
    tier: 'reversible', cues: ['last', 'rightmost', 'final', 'aakhri', 'last tab', 'rightmost tab', 'final tab', 'sabse aakhri tab'],
    reply: 'Went to the last tab in Chrome.',
  },
  {
    id: 'chrome.duplicate_tab', app: CHROME, status: 'held',
    title: 'Duplicate the Chrome tab',
    description: 'Duplicate the Chrome tab ("duplicate this tab").',
    params: {},
    steps: [{ op: 'activate' }, { op: 'menu', path: ['Tab', 'Duplicate Tab'] }],
    tier: 'reversible', cues: ['duplicate', 'clone', 'copy', 'duplicate this tab', 'copy of this tab', 'clone the tab', 'duplicate the current tab', 'duplicate tab'],
    reply: 'Duplicated the tab in Chrome.',
  },
  {
    id: 'chrome.pin_tab', app: CHROME, status: 'held',
    title: 'Pin the Chrome tab',
    description: 'Pin the Chrome tab ("pin this tab").',
    params: {},
    steps: [{ op: 'activate' }, { op: 'menu', path: ['Tab', 'Pin Tab'], pair: ['Pin Tab', 'Unpin Tab'] }],
    tier: 'reversible', cues: ['pin', 'pinned', 'pin this tab', 'pin the tab', 'keep this tab pinned', 'pin it', 'pin tab'],
    reply: 'Pinned the tab in Chrome.',
  },
  {
    id: 'chrome.unpin_tab', app: CHROME, status: 'held',
    title: 'Unpin the Chrome tab',
    description: 'Unpin the Chrome tab ("unpin this tab").',
    params: {},
    steps: [{ op: 'activate' }, { op: 'menu', path: ['Tab', 'Unpin Tab'], pair: ['Unpin Tab', 'Pin Tab'] }],
    tier: 'reversible', cues: ['unpin', 'unpin this tab', 'unpin the tab', 'unpin the current tab', 'unpin it', 'yeh tab unpin', 'unpin the pinned tab'],
    reply: 'Unpinned the tab in Chrome.',
  },
  {
    id: 'chrome.mute_tab', app: CHROME, status: 'held',
    title: "Mute the Chrome tab's site",
    description: 'Mute the Chrome tab\'s site ("mute this tab").',
    params: {},
    steps: [{ op: 'activate' }, { op: 'menu', path: ['Tab', 'Mute Site'], pair: ['Mute Site', 'Unmute Site'] }],
    tier: 'reversible', cues: ['mute', 'silence', 'awaaz', 'mute this tab', 'mute the site', 'silence this tab', 'mute the noisy tab', 'mute tab'],
    reply: 'Muted this site in Chrome.',
  },
  {
    id: 'chrome.move_tab_to_new_window', app: CHROME, status: 'held',
    title: 'Move the Chrome tab to a new window',
    description: 'Move the Chrome tab to a new window ("move this tab to a new window").',
    params: {},
    steps: [{ op: 'activate' }, { op: 'menu', path: ['Tab', 'Move Tab to New Window'] }],
    tier: 'reversible', cues: ['move', 'separate', 'alag'],
    reply: 'Moved the tab to a new Chrome window.',
  },
  {
    id: 'chrome.new_window', app: CHROME, status: 'held', opens: true,
    title: 'Open a new Chrome window',
    description: 'Open a new Chrome window ("new chrome window").',
    params: {},
    steps: [{ op: 'activate' }, { op: 'verb', id: 'chrome.new_window', params: {} }],
    tier: 'reversible', verify: 'echo', cues: ['nayi', 'another', 'new window', 'new chrome window', 'another window', 'another chrome window', 'nayi window'],
    reply: 'Opened a new Chrome window.',
  },
  {
    id: 'chrome.new_incognito_window', app: CHROME, status: 'held', opens: true,
    title: 'Open a Chrome incognito window',
    description: 'Open a Chrome incognito window ("open incognito").',
    params: {},
    steps: [{ op: 'activate' }, { op: 'verb', id: 'chrome.new_incognito_window', params: {} }],
    tier: 'reversible', verify: 'echo', cues: ['new incognito window', 'new private window', 'new incognito tab', 'another incognito window'],
    reply: 'Opened an incognito window in Chrome.',
  },
  {
    id: 'chrome.incognito_site', app: CHROME, status: 'held', opens: true,
    title: 'Open a well-known site in Chrome incognito',
    description: 'Open a well-known site in Chrome incognito ("open YouTube in incognito").',
    params: { site: { kind: 'enum', description: 'The site to open', enum: Object.values(RECIPE_SITES), labels: Object.fromEntries(Object.entries(RECIPE_SITES).map(([n, u]) => [u, n])) } },
    steps: [{ op: 'activate' }, { op: 'verb', id: 'chrome.new_incognito_window', params: {} }, { op: 'settle', ms: 300 }, { op: 'verb', id: 'chrome.navigate', params: { url: '{site}' } }],
    tier: 'reversible', verify: 'echo', cues: ['incognito', 'private', 'privately', 'incognito window'],
    reply: 'Opened {label} in an incognito window.',
  },
  {
    id: 'chrome.close_window', app: CHROME, status: 'held',
    title: 'Close the front Chrome window',
    description: 'Close the front Chrome window ("close this chrome window").',
    params: {},
    steps: [{ op: 'activate' }, { op: 'memo' }],
    onYes: [{ op: 'verb', id: 'chrome.close_window', params: {} }],
    tier: 'irreversible', verify: 'echo', cues: ['close this chrome window', 'close the window', 'shut this whole window', 'yeh window band'],
    reply: 'Close the front Chrome window and all its tabs?',
  },
  {
    id: 'chrome.back', app: CHROME, status: 'held', opens: true,
    title: 'Go back a page in Chrome',
    description: 'Go back a page in Chrome ("go back").',
    params: {},
    steps: [{ op: 'activate' }, { op: 'verb', id: 'chrome.go_back', params: {} }],
    tier: 'reversible', verify: 'echo', cues: ['back', 'previous', 'peeche', 'back a page', 'previous page', 'back one page', 'peeche jao'],
    reply: 'Went back in Chrome.',
  },
  {
    id: 'chrome.forward', app: CHROME, status: 'held', opens: true,
    title: 'Go forward a page in Chrome',
    description: 'Go forward a page in Chrome ("go forward").',
    params: {},
    steps: [{ op: 'activate' }, { op: 'verb', id: 'chrome.go_forward', params: {} }],
    tier: 'reversible', verify: 'echo', cues: ['forward', 'aage', 'forward a page', 'forward one page', 'aage jao'],
    reply: 'Went forward in Chrome.',
  },
  {
    id: 'chrome.reload', app: CHROME, status: 'held',
    title: 'Reload the Chrome tab',
    description: 'Reload the Chrome tab ("reload").',
    params: {},
    steps: [{ op: 'activate' }, { op: 'verb', id: 'chrome.reload', params: {} }],
    tier: 'reversible', verify: 'echo', cues: ['reload', 'refresh', 'refresh the page', 'reload this tab', 'refresh it', 'page refresh'],
    reply: 'Reloaded the page in Chrome.',
  },
  {
    id: 'chrome.stop_loading', app: CHROME, status: 'held',
    title: 'Stop the Chrome page loading',
    description: 'Stop the Chrome page loading ("stop loading").',
    params: {},
    steps: [{ op: 'activate' }, { op: 'verb', id: 'chrome.stop_loading', params: {} }],
    tier: 'reversible', verify: 'echo', cues: ['stop', 'cancel', 'stop loading', 'stop the page', 'stop loading this page', 'cancel the page load', 'page loading stop'],
    reply: 'Stopped loading the page.',
  },
  {
    id: 'chrome.search_youtube', app: CHROME, status: 'held', opens: true,
    title: 'Search YouTube in Chrome',
    description: 'Search YouTube in Chrome ("search YouTube for lofi beats").',
    params: { query: { kind: 'literal', description: 'The exact words to search for', cut: 'query' } },
    steps: [{ op: 'activate' }, { op: 'verb', id: 'chrome.open_tab', params: { url: 'https://www.youtube.com/results?search_query={query}' } }],
    tier: 'reversible', verify: 'echo', names: ['youtube'], cues: ['search', 'look', 'find'],
    reply: 'Searched YouTube for {query}.',
  },
  {
    id: 'chrome.search_google_images', app: CHROME, status: 'held', opens: true,
    title: 'Search Google Images in Chrome',
    description: 'Search Google Images in Chrome ("search google images for red sneakers").',
    params: { query: { kind: 'literal', description: 'The exact words to search for', cut: 'query' } },
    steps: [{ op: 'activate' }, { op: 'verb', id: 'chrome.open_tab', params: { url: 'https://www.google.com/search?udm=2&q={query}' } }],
    tier: 'reversible', verify: 'echo', names: ['google images'], cues: ['search', 'look', 'find'],
    reply: 'Searched Google Images for {query}.',
  },
  {
    id: 'chrome.search_github', app: CHROME, status: 'held', opens: true,
    title: 'Search GitHub in Chrome',
    description: 'Search GitHub in Chrome ("look up react hooks on github").',
    params: { query: { kind: 'literal', description: 'The exact words to search for', cut: 'query' } },
    steps: [{ op: 'activate' }, { op: 'verb', id: 'chrome.open_tab', params: { url: 'https://github.com/search?q={query}' } }],
    tier: 'reversible', verify: 'echo', names: ['github'], cues: ['search', 'look', 'find'],
    reply: 'Searched GitHub for {query}.',
  },
  {
    id: 'chrome.search_reddit', app: CHROME, status: 'held', opens: true,
    title: 'Search Reddit in Chrome',
    description: 'Search Reddit in Chrome ("search reddit for macbook battery tips").',
    params: { query: { kind: 'literal', description: 'The exact words to search for', cut: 'query' } },
    steps: [{ op: 'activate' }, { op: 'verb', id: 'chrome.open_tab', params: { url: 'https://www.reddit.com/search/?q={query}' } }],
    tier: 'reversible', verify: 'echo', names: ['reddit'], cues: ['search', 'look', 'find'],
    reply: 'Searched Reddit for {query}.',
  },
  {
    id: 'chrome.search_x', app: CHROME, status: 'held', opens: true,
    title: 'Search X in Chrome',
    description: 'Search X in Chrome ("search x for vestra launch").',
    params: { query: { kind: 'literal', description: 'The exact words to search for', cut: 'query' } },
    steps: [{ op: 'activate' }, { op: 'verb', id: 'chrome.open_tab', params: { url: 'https://x.com/search?q={query}' } }],
    tier: 'reversible', verify: 'echo', names: ['twitter'], cues: ['search', 'look', 'find'],
    reply: 'Searched X for {query}.',
  },
  {
    id: 'chrome.search_linkedin', app: CHROME, status: 'held', opens: true,
    title: 'Search LinkedIn in Chrome',
    description: 'Search LinkedIn in Chrome ("search linkedin for product designers").',
    params: { query: { kind: 'literal', description: 'The exact words to search for', cut: 'query' } },
    steps: [{ op: 'activate' }, { op: 'verb', id: 'chrome.open_tab', params: { url: 'https://www.linkedin.com/search/results/all/?keywords={query}' } }],
    tier: 'reversible', verify: 'echo', names: ['linkedin'], cues: ['search', 'look', 'find'],
    reply: 'Searched LinkedIn for {query}.',
  },
  {
    id: 'chrome.find_in_page', app: CHROME, status: 'held', opens: true,
    title: 'Find words on the Chrome page',
    description: 'Find words on the Chrome page ("find pricing on this page").',
    params: { text: { kind: 'literal', description: 'The exact words to find', cut: ['query', 'after_saying'] } },
    steps: [{ op: 'activate' }, { op: 'focus_mark' }, { op: 'key', chord: 'cmd+f' }, { op: 'focus_moved', timeoutMs: 800, labelIn: ['find in page', 'find'] }, { op: 'type', param: 'text' }],
    tier: 'reversible', cues: ['find', 'page', 'where', 'dhundo', 'search this page', 'this page'],
    reply: 'Looking for {text} on the page.',
  },
  {
    id: 'chrome.find_next', app: CHROME, status: 'held', opens: true,
    title: 'Next match on the Chrome page',
    description: 'Next match on the Chrome page ("next match").',
    params: {},
    steps: [{ op: 'activate' }, { op: 'key', chord: 'cmd+g' }],
    tier: 'reversible', cues: ['match', 'result', 'occurrence', 'next match', 'next occurrence', 'agla match'],
    reply: 'Next match.',
  },
  {
    id: 'chrome.find_previous', app: CHROME, status: 'held', opens: true,
    title: 'Previous match on the Chrome page',
    description: 'Previous match on the Chrome page ("previous match").',
    params: {},
    steps: [{ op: 'activate' }, { op: 'key', chord: 'cmd+shift+g' }],
    tier: 'reversible', cues: ['match', 'result', 'occurrence', 'previous match', 'back one match', 'pichla match', 'previous result'],
    reply: 'Previous match.',
  },
  {
    id: 'chrome.zoom_in', app: CHROME, status: 'held',
    title: 'Zoom in on the Chrome page',
    description: 'Zoom in on the Chrome page ("zoom in").',
    params: {},
    steps: [{ op: 'activate' }, { op: 'key', chord: 'cmd+=' }],
    tier: 'reversible', cues: ['zoom', 'bigger', 'larger', 'enlarge', 'bada', 'zoom in', 'it bigger', 'text larger', 'zoom in a bit'],
    reply: 'Zoomed in.',
  },
  {
    id: 'chrome.zoom_out', app: CHROME, status: 'held',
    title: 'Zoom out on the Chrome page',
    description: 'Zoom out on the Chrome page ("zoom out").',
    params: {},
    steps: [{ op: 'activate' }, { op: 'key', chord: 'cmd+-' }],
    tier: 'reversible', cues: ['zoom', 'smaller', 'shrink', 'chhota', 'zoom out', 'it smaller', 'shrink the page'],
    reply: 'Zoomed out.',
  },
  {
    id: 'chrome.zoom_reset', app: CHROME, status: 'held',
    title: 'Reset the Chrome page zoom',
    description: 'Reset the Chrome page zoom ("reset zoom").',
    params: {},
    steps: [{ op: 'activate' }, { op: 'key', chord: 'cmd+0' }],
    tier: 'reversible', cues: ['zoom', 'actual', 'normal', 'reset', 'actual size', 'back to normal size', 'zoom to 100 percent', 'undo the zoom in', 'normal size'],
    reply: 'Reset the zoom.',
  },
  {
    id: 'chrome.enter_full_screen', app: CHROME, status: 'held',
    title: 'Put Chrome in full screen',
    description: 'Chrome full screen on ("full screen").',
    params: {},
    steps: [{ op: 'activate' }, { op: 'menu', path: ['View', 'Enter Full Screen'], pair: ['Enter Full Screen', 'Exit Full Screen'] }],
    tier: 'reversible', cues: ['full screen', 'fullscreen'],
    reply: 'Chrome is full screen.',
  },
  {
    id: 'chrome.exit_full_screen', app: CHROME, status: 'held',
    title: 'Take Chrome out of full screen',
    description: 'Chrome full screen off ("exit full screen").',
    params: {},
    steps: [{ op: 'activate' }, { op: 'menu', path: ['View', 'Exit Full Screen'], pair: ['Exit Full Screen', 'Enter Full Screen'] }],
    tier: 'reversible', cues: ['exit', 'leave', 'hatao', 'out', 'exit full screen', 'exit fullscreen', 'leave fullscreen', 'leave full screen', 'full screen hatao', 'out of full screen'],
    reply: 'Chrome is out of full screen.',
  },
  {
    id: 'chrome.focus_address_bar', app: CHROME, status: 'held',
    title: "Put the cursor in Chrome's address bar",
    description: 'Put the cursor in Chrome\'s address bar ("go to the address bar").',
    params: {},
    steps: [{ op: 'activate' }, { op: 'focus_mark' }, { op: 'key', chord: 'cmd+l' }, { op: 'focus_moved', timeoutMs: 800, labelIn: ['address and search bar'] }],
    tier: 'reversible', cues: ['address', 'url', 'omnibox', 'location', 'address bar', 'focus the url bar', 'select the omnibox', 'address bar pe jao'],
    reply: 'The address bar is ready.',
  },
  {
    id: 'chrome.copy_url', app: CHROME, status: 'held',
    title: "Copy the Chrome tab's link",
    description: 'Copy the Chrome tab\'s link ("copy the link").',
    params: {},
    steps: [{ op: 'activate' }, { op: 'focus_mark' }, { op: 'key', chord: 'cmd+l' }, { op: 'focus_moved', timeoutMs: 800, labelIn: ['address and search bar'] }, { op: 'key', chord: 'cmd+c' }, { op: 'key', chord: 'escape' }, { op: 'verb', id: 'system.clipboard_read', params: {} }],
    tier: 'reversible', verify: 'echo', cues: ['copy', 'link', 'url', 'copy this', 'copy the page address'],
    reply: 'Copied the link.',
  },
  {
    id: 'chrome.bookmark_page', app: CHROME, status: 'held',
    title: 'Bookmark the Chrome page',
    description: 'Bookmark the Chrome page ("bookmark this page").',
    params: {},
    steps: [{ op: 'activate' }, { op: 'verb', id: 'chrome.add_bookmark', params: {} }],
    tier: 'reversible', verify: 'echo', cues: ['bookmark', 'star', 'bookmark this page', 'bookmark this', 'add a bookmark', 'star this page', 'isko bookmark'],
    reply: 'Bookmarked it on your bookmarks bar.',
  },
  {
    id: 'chrome.settings', app: CHROME, status: 'held', opens: true,
    title: 'Open Chrome settings',
    description: 'Open Chrome settings ("open chrome settings").',
    params: {},
    steps: [{ op: 'activate' }, { op: 'key', chord: 'cmd+,' }],
    tier: 'reversible', cues: ['settings', 'preferences'],
    reply: 'Opened Chrome settings.',
  },
  {
    id: 'chrome.extensions', app: CHROME, status: 'held', opens: true,
    title: 'Open Chrome extensions',
    description: 'Open Chrome extensions ("show my extensions").',
    params: {},
    steps: [{ op: 'activate' }, { op: 'menu', path: ['Window', 'Extensions'] }],
    tier: 'reversible', cues: ['extensions', 'extension', 'plugins', 'addons', 'manage extensions', 'extensions page'],
    reply: 'Opened your extensions in Chrome.',
  },
  // Printing is outward (the catalog audit leaves prints for the yes); the yes only opens the dialog.
  {
    id: 'chrome.print', app: CHROME, status: 'held',
    title: 'Open print for the Chrome page',
    description: 'Open print for the Chrome page ("print this page").',
    params: {},
    steps: [{ op: 'activate' }, { op: 'memo' }],
    onYes: [{ op: 'key', chord: 'cmd+p' }],
    tier: 'irreversible', cues: ['print', 'print this page', 'print this'],
    reply: 'Open the print window for this page in Chrome?',
  },  // ── R3c: the catalog rulings' accepts ─────────────────────────────────────────────────────────
  // Each opens a new tab or a panel through the menu bar, never a key the page in front could take.
  {
    id: 'chrome.history', app: CHROME, status: 'held', opens: true,
    title: 'Open Chrome history',
    description: 'Open Chrome history in a new tab ("open my history").',
    params: {},
    steps: [{ op: 'activate' }, { op: 'menu', path: ['History', 'Show Full History'] }],
    tier: 'reversible', cues: ['history', 'browsing history', 'history dikhao'],
    reply: 'Opened your history in Chrome.',
  },
  {
    id: 'chrome.downloads', app: CHROME, status: 'held', opens: true,
    title: 'Open Chrome downloads',
    description: 'Open Chrome downloads in a new tab ("show my downloads in chrome").',
    params: {},
    steps: [{ op: 'activate' }, { op: 'menu', path: ['Window', 'Downloads'] }],
    tier: 'reversible', cues: ['downloads', 'download', 'downloaded', 'downloads page', 'downloads kholo'],
    reply: 'Opened your downloads in Chrome.',
  },
  // A toggle: asked while the panel is open, it closes it, so the reply says toggled.
  {
    id: 'chrome.dev_tools', app: CHROME, status: 'held',
    title: 'Toggle Chrome developer tools',
    description: 'Toggle Chrome developer tools ("open dev tools").',
    params: {},
    steps: [{ op: 'activate' }, { op: 'menu', path: ['View', 'Developer', 'Developer Tools'] }],
    tier: 'reversible', cues: ['devtools', 'dev', 'developer', 'inspect', 'inspector', 'dev tools', 'developer tools', 'inspect this page'],
    reply: 'Toggled the developer tools in Chrome.',
  },
  // "console" is also the Console app's name, so today every ask for it is the model's.
  {
    id: 'chrome.js_console', app: CHROME, status: 'held', opens: true,
    title: 'Open the Chrome JavaScript console',
    description: 'Open the Chrome JavaScript console ("open the javascript console").',
    params: {},
    steps: [{ op: 'activate' }, { op: 'menu', path: ['View', 'Developer', 'JavaScript Console'] }],
    tier: 'reversible', cues: ['console', 'javascript console', 'js console', 'dev console'],
    reply: 'Opened the JavaScript console in Chrome.',
  },
  // Wikipedia's search page lists results (fulltext=1), so a title match never opens a page on its own.
  {
    id: 'chrome.search_wikipedia', app: CHROME, status: 'held', opens: true,
    title: 'Search Wikipedia in Chrome',
    description: 'Search Wikipedia in Chrome ("search wikipedia for the mughal empire").',
    params: { query: { kind: 'literal', description: 'The exact words to search for', cut: 'query' } },
    steps: [{ op: 'activate' }, { op: 'verb', id: 'chrome.open_tab', params: { url: 'https://en.wikipedia.org/w/index.php?fulltext=1&search={query}' } }],
    tier: 'reversible', verify: 'echo', names: ['wikipedia'], cues: ['search', 'look', 'find'],
    reply: 'Searched Wikipedia for {query}.',
  },
  // Google's map search. "maps" is also the Maps app's name, so today these asks are the model's.
  {
    id: 'chrome.search_google_maps', app: CHROME, status: 'held', opens: true,
    title: 'Search Google Maps in Chrome',
    description: 'Search Google Maps in Chrome ("find coffee near me on google maps").',
    params: { query: { kind: 'literal', description: 'The exact words to search for', cut: 'query' } },
    steps: [{ op: 'activate' }, { op: 'verb', id: 'chrome.open_tab', params: { url: 'https://www.google.com/maps/search/{query}' } }],
    tier: 'reversible', verify: 'echo', names: ['google maps'], cues: ['search', 'look', 'find'],
    reply: 'Searched Google Maps for {query}.',
  },
];
